// src/Store/Slice/UserSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  register: false,
  login: false,
  forgetPassword: false,
  navigationPath: null,
};

const siteSlice = createSlice({
  name: "siteSlice",
  initialState,
  reducers: {
    // ✅ one reducer: can update one field or many fields
    openAuthModal(state, action) {
      if (action.payload == "register") {
        ((state.login = false),
          (state.register = true),
          (state.forgetPassword = false));
      }
      if (action.payload == "login") {
        ((state.login = true),
          (state.register = false),
          (state.forgetPassword = false));
      }
      if (action.payload == "forgetPass") {
        ((state.login = false),
          (state.register = false),
          (state.forgetPassword = true));
      }
    },
    setNavigationPath(state, action) {
      if (action.payload == "register") {
        ((state.login = false),
          (state.register = true),
          (state.forgetPassword = false));
      }
      state.navigationPath = action.payload?.path || null;
    },
    closeModal(state, action) {
    

      ((state.login = false),
        (state.register = false),
        (state.forgetPassword = false));
    },
  },
});

export const { openAuthModal, closeModal, setNavigationPath } =
  siteSlice.actions;
export default siteSlice.reducer;
